import { render, staticRenderFns } from "./flower.vue?vue&type=template&id=746a5e0d&scoped=true&"
import script from "./flower.vue?vue&type=script&lang=js&"
export * from "./flower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746a5e0d",
  null
  
)

export default component.exports